import { Home, Stethoscope, Sparkles, GraduationCap, HardDrive } from "lucide-react";

const items = [
  {
    icon: Home,
    title: "Intervention à domicile",
    desc: "Je me déplace directement chez vous en Île-de-France pour monter, dépanner ou upgrader votre PC sur place. Pratique pour les setups déjà installés.",
    highlight: true,
  },
  {
    icon: Stethoscope,
    title: "Diagnostic & dépannage",
    desc: "PC qui plante, qui rame, qui s'éteint ? Je trouve la cause.",
  },
  {
    icon: Sparkles,
    title: "Nettoyage & optimisation",
    desc: "Dépoussiérage complet, pâte thermique, optimisation Windows.",
  },
  {
    icon: GraduationCap,
    title: "Conseil à l'achat",
    desc: "Accompagnement configuration : on choisit ensemble la bonne config.",
  },
  {
    icon: HardDrive,
    title: "Upgrade de composants",
    desc: "Ajout RAM, nouveau GPU, SSD, watercooling : upgrade ciblé.",
  },
];

export default function AdditionalServices() {
  return (
    <section
      data-testid="additional-services-section"
      className="relative py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
            // Services additionnels
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight">
            Au-delà du montage.
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`additional-service-${i}`}
                className={`reveal rounded-xl p-5 transition-all hover:-translate-y-0.5 ${
                  it.highlight
                    ? "gradient-border shadow-violet-soft hover:shadow-violet"
                    : "border border-white/10 bg-zinc-900/40 hover:border-violet-400/40"
                }`}
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <Icon className={`h-5 w-5 ${it.highlight ? "text-violet-200" : "text-violet-300"}`} />
                <h3 className="mt-4 font-display text-base font-semibold">
                  {it.title}
                </h3>
                <p className="mt-1.5 text-sm text-zinc-400 leading-relaxed">
                  {it.desc}
                </p>
                {it.highlight && (
                  <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-violet-500/15 border border-violet-500/40 px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider text-violet-300">
                    Nouveau
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
